const bodycertificatecontentEN = [

{id:0,
title:"Certificates",
img:"https://raw.githubusercontent.com/RamonFavero/ramonportfolio/main/src/img/udemy-certificate.jpg",
title2:"Full-Stack bootcamp certificate by Angela Yu:",
corpo:"An all-in-one course with a simple and easy-to-understand language with a progression to a more technical language as the course expands. In addition to all the technical lessons I was provided, the thing I appreciate most on this bootcamp was the focus on teaching us how to read documentation. For every language, API or website there is an official and reliable documentation."
},
{id:1,
title:"Certificates",
img:"https://raw.githubusercontent.com/RamonFavero/ramonportfolio/main/src/img/udemy-certificate-python.jpg",
title2:"Python course certificate by Maximilian Schwarzmüller:",
corpo:"I found pretty greedy the idea of teaching blockchain as a first project for a beginner, but soon I realized that the basics of the language were being applied exceptionally! I must highlight the teacher's ability to apply error management and introduce the subject of scalability."
},
]
export default bodycertificatecontentEN